import { useState } from "react";
import { useNavigate } from "react-router-dom";

type SearchFieldProps = {
  defaultValue?: string;
  placeholder?: string;
  size?: "md" | "lg";
  buttonLabel?: string;
};

export default function SearchField({
  defaultValue = "",
  placeholder = "输入影片名称、导演或类型",
  size = "md",
  buttonLabel = "搜索影片",
}: SearchFieldProps) {
  const navigate = useNavigate();
  const [value, setValue] = useState(defaultValue);

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = value.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  const heightClass = size === "lg" ? "h-12 md:h-14" : "h-11";
  const textClass = size === "lg" ? "text-sm md:text-[15px]" : "text-sm";

  return (
    <form onSubmit={onSubmit} className="flex w-full flex-col gap-2 sm:flex-row">
      <div className="relative flex-1">
        <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-400" />
        <input
          type="text"
          name="keyword"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={placeholder}
          aria-label="搜索影片"
          className={`${heightClass} w-full rounded-md border border-background-300 bg-background-50 pl-11 pr-4 ${textClass} text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200/70`}
        />
      </div>
      <button
        type="submit"
        className={`${heightClass} inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600`}
      >
        <i className="ri-search-eye-line text-base w-4 h-4 flex items-center justify-center" />
        {buttonLabel}
      </button>
    </form>
  );
}